import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import HighCharts from 'highcharts';
import numeral from 'numeral';
import 'numeral/locales/it';
import ShowComponent from '../hocs/ShowComponent';

@ShowComponent
@observer
class OverviewInterestPaymentComparisonComponent extends React.Component {
  componentDidMount() {
    const {
      extraAmountForCategory,
      interests,
      categories,
      baseAmount,
      barWidth,
    } = this.props;

    const { labels } = this.props.CalculationFormData.mortgageForm;

    if (interests.length > 0) {
      HighCharts.chart('looptijdrente-barchart', {
        chart: {
          type: 'column',
          height: 425,
        },
        title: {
          text: '',
        },
        xAxis: {
          categories,
          labels: {
            useHTML: true,
            formatter() {
              const baseDifference = interests[this.pos].baseAmountDifference;
              let baseDifferenceText = '';
              if (baseDifference > 0) {
                baseDifferenceText = `+ ${numeral(baseDifference).format('$ 0,00')}`;
              }

              const labelName = numeral(interests[this.pos].labelName).format('$ 0,00');

              const bankLabel = labels.find(label => label.id === interests[this.pos].labelId);
              const logo = bankLabel ? bankLabel.logo : '';

              return (`
              <span class="overview-container__bar-chart__x-data-total-amount">
                ${labelName}
              </span><br>
             <span class="overview-container__bar-chart__x-data-interest-difference">
                ${baseDifferenceText}
             </span>
             <br>
             <br>
             <img src="${logo}"/>
            `);
            },
            rotation: 0,
          },
        },
        yAxis: {
          min: Math.round(baseAmount / 2),
          title: {
            text: '',
          },
          labels: {
            formatter() {
              return `€${this.value}`;
            },
          },
          stackLabels: {
            enabled: false,
            style: {
              fontWeight: 'bold',
              color: (HighCharts.theme && HighCharts.theme.textColor) || 'gray',
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: 'bottom',
              // style: { top: '105px', fontWeight: 'bold' },
              color: (HighCharts.theme && HighCharts.theme.dataLabelsColor) || 'white',
              formatter() {
                let dataLabel;
                if (this.y === baseAmount) {
                  const value = interests.find(item => item.category === this.x);

                  let showTermInterestRateIcon = '';

                  if (value.riskClassReduction) {
                    showTermInterestRateIcon = `
                    <img 
                      src="/images/looptijdrente-icoon-lichtblauw.svg" 
                      alt="looptijdrente icoon lichtblauw">`;
                  }
                  dataLabel = (
                    `<div class="overview-container__bar-chart__y-data-labels">
                    ${showTermInterestRateIcon}
                    <div class="overview-container__bar-chart__interest">${value.val}%</div>
                  </div>`
                  );
                }

                return dataLabel;
              },
            },
          },
        },
        series: [{
          name: 'Residu',
          data: extraAmountForCategory,
          pointWidth: barWidth,
          color: '#b9c5d5',
        }, {
          name: 'Base',
          data: Array(interests.length).fill(baseAmount),
          pointWidth: barWidth,
          color: '#1a3558',
        }],
      });
    }
  }

  render() {
    return (
      <div className={'no-mobile'}>
        <div id="looptijdrente-barchart" />
      </div>
    );
  }
}

OverviewInterestPaymentComparisonComponent.propTypes = {
  CalculationFormData: PropTypes.shape({
    mortgageForm: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  extraAmountForCategory: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.shape({}),
  ]),
  interests: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  categories: PropTypes.arrayOf(PropTypes.string),
  baseAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  barWidth: PropTypes.number,
};

OverviewInterestPaymentComparisonComponent.defaultProps = {
  CalculationFormData: {
    mortgageForm: {
      labels: [],
    },
  },
  extraAmountForCategory: [],
  interests: [],
  categories: [],
  baseAmount: '',
  barWidth: 0,
};

export default inject('CalculationFormData')(OverviewInterestPaymentComparisonComponent);
